import { memo } from 'react';
import classnames from 'classnames';
import DOMPurify from 'dompurify';

export const ContentText = memo(({ title, text, img, textRightSide = false }) => {
  return (
    <div className="container">
      {title && <h3 className="container-title">{title}</h3>}
      <div className={classnames("content", {
        'content-right-text': textRightSide
      })}>
        <div className="content-text">
          {text.map(paragraph =>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(paragraph) }}/>
          )}
        </div>
        <div className="content-picture">
          <img src={img} alt="Złote Lwy Marienburga" loading="lazy" />
        </div>
      </div>
    </div>
  )
});

export default ContentText;